const HeroVariant4 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center text-center px-4 py-20"
      style={{ backgroundColor: theme.backgroundColor, fontFamily: font.mainText }}
    >
      <h1
        className="text-6xl font-extrabold mb-6 leading-tight"
        style={{ color: theme.primaryColor }}
      >
        {renderEditable
          ? renderEditable("heading", getText("heading", "Unlock Limitless Possibilities"))
          : getText("heading", "Unlock Limitless Possibilities")}
      </h1>
      <p
        className="text-xl max-w-3xl mb-10"
        style={{ color: theme.textColor }}
      >
        {renderEditable
          ? renderEditable("subheading", getText("subheading", "From startups to enterprises, our tools empower you to build fast and scale smart."))
          : getText("subheading", "From startups to enterprises, our tools empower you to build fast and scale smart.")}
      </p>
      <button
        className="px-8 py-4 rounded-full text-lg font-semibold shadow-lg transition-transform hover:scale-105"
        style={{ backgroundColor: theme.primaryColor, color: theme.backgroundColor }}
      >
        {renderEditable
          ? renderEditable("primaryButton", getText("primaryButton", "Join the Revolution"))
          : getText("primaryButton", "Join the Revolution")}
      </button>
    </div>
  );
};

export default HeroVariant4;
